import { memo as Memo } from 'react';

//* Components
import Text from '@components/global/Text';

const DefaultCheckbox = Memo((props) => {
	return (
		<div className={`def-checkbox ${props.checked ? 'checked' : ''}`}>
			<Text
				tag={'span'}
				className='def-checkbox-el'>
				<input
					name={props.name}
					label={props.label}
					type={props.inputType || 'checkbox'}
					onChange={() => props.onChange && props.onChange(props.value)}
					checked={props.checked}
				/>
			</Text>

			<Text
				tag={'label'}
				className={`def-checkbox-name`}
				onClick={() => props.onChange && props.onChange(props.value)}
				text={props.label}
			/>
		</div>
	);
});

export default DefaultCheckbox;
